import { FC } from 'react'
import { ModalBackdrop, ModalContainer, ModalContent } from 'is24-corecss'
import { Trans, useTranslation } from 'react-i18next'
import { ButtonBack, ButtonNext, CarouselProvider, DotGroup, Slide, Slider } from 'pure-react-carousel'
import { IconS24ChevronLeft24, IconS24ChevronRight24 } from '@is24/cosma-ui-icons'
import './TooltipModal.css'

export interface TooltipModalProps {
  isOpen: boolean
  tooltipKey: string
  namespace?: string
  onClose: () => void
}

export const TooltipModal: FC<TooltipModalProps> = ({ isOpen, tooltipKey, namespace, onClose }: TooltipModalProps) => {
  const { t, i18n } = useTranslation(namespace)
  const tipsKey = `${tooltipKey}.tips`
  //@ts-ignore
  const tips: string[] = t(tipsKey, { returnObjects: true })

  return (
    <ModalBackdrop visible={isOpen} onClose={onClose}>
      <ModalContainer
        width={'unset'}
        containerClassName='tooltip-modal'
        visible={isOpen}
        onClose={onClose}
        ariaLabelCloseButton='close'
        modalTitle={t(`${tooltipKey}.title`)}
      >
        <ModalContent>
          {i18n.exists(tipsKey, { ns: namespace }) && (
            <CarouselProvider
              naturalSlideWidth={100}
              naturalSlideHeight={125}
              isIntrinsicHeight={true}
              totalSlides={tips.length}
              infinite={true}
            >
              <Slider horizontalPixelThreshold={30}>
                {tips.map((tip, index) => (
                  <Slide index={index} key={tip}>
                    <Trans i18nKey={tip} />
                  </Slide>
                ))}
              </Slider>
              {tips.length > 1 && (
                <div className='carousel-navigation'>
                  <div className='grid grid-flex grid-justify-center grid-align-center padding-top-m'>
                    <div className='carousel-button-container'>
                      <ButtonBack className='button-icon-standalone'>
                        <IconS24ChevronLeft24 />
                      </ButtonBack>
                    </div>
                    <div className='grid-item'>
                      <DotGroup
                        className='grid grid-flex grid-justify-center'
                        renderDots={({ currentSlide }) =>
                          tips.map((tip, index) => (
                            <div
                              className={`carousel-dot ${currentSlide === index ? 'carousel-dot--active' : ''}`}
                              key={tip + index}
                            ></div>
                          ))
                        }
                      />
                    </div>
                    <div className='carousel-button-container'>
                      <ButtonNext className='button-icon-standalone'>
                        <IconS24ChevronRight24 />
                      </ButtonNext>
                    </div>
                  </div>
                </div>
              )}
            </CarouselProvider>
          )}
        </ModalContent>
      </ModalContainer>
    </ModalBackdrop>
  )
}
